<template>
    <div>
        <div class="mx-auto w-1/2 text-center">
            <h1 class="first-letter:uppercase text-heading-1 font-semibold mr-auto mb-16">{{ $t('import.step_1.lets_go') }}</h1>
            <p class="text-primary-80 mb-32">{{ $t('import.step_1.description') }}</p>

            <file-upload ref="file"
                         :center-items="true"
                         :value="file"
                         only-accept=".csv"
                         type="document"
                         without-upload
                         @input="$emit('setFile', $event)"
                         @removed="$emit('removeFile', $event)"/>

            <p v-if="data" class="text-primary-80 my-32">{{ $t('import.step_1.rows_found', {amount: data.length}) }}</p>
        </div>

        <div v-if="data && data.length" class="mt-32 flex justify-center space-x-24">
            <simple-button class="uppercase w-200"
                           display="secondary"
                           look="primary"
                           @click="$emit('next')">
                {{ $t('jobs.next_step') }}
            </simple-button>
        </div>
    </div>
</template>

<script>
import SimpleButton from '../SimpleButton';
import FileUpload from '../../forms/FileUpload';
import SvgIcon from '../SvgIcon';

export default {
    components: {SvgIcon, FileUpload, SimpleButton},
    props: {
        file: File,
        data: Array,
        fields: Array,
    },
    data() {
        return {
            working: false,
        };
    },
    mounted() {
        if (this.file) {
            this.$refs.file.setFiles([this.file]);
        }
    },
};
</script>
